import { IssueType, IssuePriority } from '@/entities/issue';

export interface IssuePhoto {
  image_id: string | null;
  thumbnail_id: string | null;
  height: number | null;
  width: number | null;
  uuid: string;
  drawing_id: string | null;
}

export interface IssueRecordEditable {
  title: string;
  description: string | null;
  assignees: Array<number | string>;
  associateAssignees: Array<number | string>;
  status: number;
  entityItem: number | null;
  priority: number;
  suggestedCorrectiveAction: string | null;
  performedCorrectiveAction: string | null;
  deadline: Date | null;
  photos: Array<IssuePhoto> | null;
  question: null | number;
  type: IssueType | null;
  assignedGroups: Array<number | string>;
  approval: { id: number; status: string } | null;
}

export const emptyIssue = (): IssueRecordEditable => {
  return {
    title: '',
    description: '',
    assignees: [],
    associateAssignees: [],
    status: 0,
    entityItem: null,
    priority: IssuePriority.Normal,
    suggestedCorrectiveAction: '',
    performedCorrectiveAction: '',
    deadline: null,
    photos: [],
    question: null,
    type: null,
    assignedGroups: [],
    approval: null,
  };
};
